import { ITEM_STATUS } from 'src/helpers'
import { ApplianceType, GroupedItem, Item, ItemByCategory } from '../types'

/** TYPES **/
export const itemsTypes = {
  FETCH_ITEMS: 'FETCH_ITEMS',
  FETCH_INSPECTION_ITEMS: 'FETCH_INSPECTION_ITEMS',
  FETCH_ITEMS_BY_CATEGORY: 'FETCH_ITEMS_BY_CATEGORY',
  SET_ITEMS: 'SET_ITEMS',
  SET_INSPECTION_ITEMS: 'SET_INSPECTION_ITEMS',
  SET_ITEMS_BY_CATEGORY: 'SET_ITEMS_BY_CATEGORY',
  UPDATE_ITEM: 'UPDATE_ITEM',
  UPDATE_ITEM_TOTALS_SYNC: 'UPDATE_ITEM_TOTALS_SYNC',
  DELETE_ITEM: 'DELETE_ITEM',
  UPDATE_BATCH: 'UPDATE_BATCH',
  DELETE_BATCH: 'DELETE_BATCH',
  CREATE_ITEM: 'CREATE_ITEM',
  REJECT_ITEM: 'REJECT_ITEM',
  RECALL_ITEM: 'RECALL_ITEM',
  MOVE_ITEMS: 'MOVE_ITEMS',
  MOVE_ITEMS_TO_JOB: 'MOVE_ITEMS_TO_JOB',
  MOVE_ITEMS_TO_ESTIMATE: 'MOVE_ITEMS_TO_ESTIMATE',
  RECOVER_ITEM: 'RECOVER_ITEM',
  CREATE_ITEM_FROM_CSV: 'CREATE_ITEM_FROM_CSV',
  UPDATE_ITEM_TOTALS: 'UPDATE_ITEM_TOTALS',
  DELETE_ESTIMATE_ITEMS: 'DELETE_ESTIMATE_ITEMS',
  UPDATE_ITEM_BY_PATH: 'UPDATE_ITEM_BY_PATH',
  COMBINE_ITEMS: 'COMBINE_ITEMS',
  FETCH_RECOMMENDED_ITEMS: 'FETCH_RECOMMENDED_ITEMS',
  SET_RECOMMENDED_ITEMS: 'SET_RECOMMENDED_ITEMS',
  DOWNLOAD_ITEMS_CSV: 'DOWNLOAD_ITEMS_CSV',
  FETCH_APPLIANCE_TYPES: 'FETCH_APPLIANCE_TYPES',
  SET_APPLIANCE_TYPES: 'SET_APPLIANCE_TYPES',
  SCAN_APPLIANCE_TAG: 'SCAN_APPLIANCE_TAG',
  CONFIRM_APPLIANCE_TAG: 'CONFIRM_APPLIANCE_TAG',
  SET_APPLIANCE_TAG_DATA: 'SET_APPLIANCE_TAG_DATA',
  CLONE_ITEM: 'CLONE_ITEM',
  EDIT_LABOR_RATE_BY_TERRITORY_AND_CATEGORY: 'EDIT_LABOR_RATE_BY_TERRITORY_AND_CATEGORY',
}


/** ACTIONS **/
export interface FetchItemsAction {
  type: typeof itemsTypes.FETCH_ITEMS
  payload: {
    params?: Partial<ItemsParams>
  }
  callback?: (succ: boolean, count?: number, items?: Item[]) => void
}
export interface FetchInspectionItemsAction {
  type: typeof itemsTypes.FETCH_INSPECTION_ITEMS
  payload: {
    params?: Partial<ItemsParams>
  }
  callback?: (succ: boolean, count?: number, items?: Item[]) => void
}

export interface ScanApplianceTagAction {
  type: typeof itemsTypes.SCAN_APPLIANCE_TAG
  payload: ScanLabel
  callback?: (succ: boolean, scanLabelData?: ScanLabel) => void
}

export interface ConfirmApplianceTagAction {
  type: typeof itemsTypes.CONFIRM_APPLIANCE_TAG
  payload: ConfirmAppliance
  callback?: (succ: boolean, appliance?: ConfirmAppliance) => void
}



export interface FetchItemsCountAction {
  type: typeof itemsTypes.FETCH_ITEMS
  payload: {
    params?: Partial<ItemsParams>
  }
  callback?: (succ: boolean, count: number) => void
}

export interface FetchApplianceTypesAction {
  type: typeof itemsTypes.FETCH_APPLIANCE_TYPES
  payload: undefined,
  callback?: (succ: boolean) => void
}

export interface SetItemsAction {
  type: typeof itemsTypes.SET_ITEMS
  payload: Item[]
}

export interface SetItemsByCategoryAction {
  type: typeof itemsTypes.SET_ITEMS
  payload: GroupedItem[]
}
export interface UpdateItemPayload {
  itemId: string
  partialItem: Partial<Item>
  selectedOrderId?: string
  isEstimate?: boolean
}
export interface DeleteItemPayload {
  itemId: string
  selectedOrderId?: string
  jobId: string
}

export interface UpdateItemAction {
  type: typeof itemsTypes.UPDATE_ITEM
  payload: any
  callback?: (succ: boolean, newItem?: Item) => void
}

export interface DeleteItemAction {
  type: typeof itemsTypes.DELETE_ITEM
  payload: DeleteItemPayload
  callback?: (succ: boolean) => void
}

export interface UpdateBatchPayload {
  itemsIds: string[]
  id?: string
  partialItem: Partial<Item>
  selectedOrderId?: string
}

export interface DeleteBatchPayload {
  itemsIds: string[]
  jobId: string
  selectedOrderId?: string
}

export interface RejectBatchPayload {
  id: string
  itemId: string
  partialItem: {
    followupNotes?: string
    status: ITEM_STATUS
    imageFiles?: any[]
  }
}

export interface DeleteEstimateItemsAction {
  type: typeof itemsTypes.DELETE_ESTIMATE_ITEMS
  payload: string
  callback?: (succ: boolean) => void
}

export interface UpdateBatchAction {
  type: typeof itemsTypes.UPDATE_BATCH
  payload: UpdateBatchPayload
  callback?: (succ: boolean) => void
}

export interface DeleteBatchAction {
  type: typeof itemsTypes.DELETE_BATCH
  payload: DeleteBatchPayload
  callback?: (succ: boolean) => void
}

export interface CreateItemAction {
  type: typeof itemsTypes.CREATE_ITEM
  //replace with CreateItemRequest
  payload: any
  callback: (succ: boolean, item?: Item) => void
}

export interface RecallItemsAction {
  type: typeof itemsTypes.RECALL_ITEM
  payload: {
    items: Item[]
    id: string
  }
  callback: (succ: boolean, item: Item | null) => void
}

export interface RecoverItemAction {
  type: typeof itemsTypes.RECOVER_ITEM
  payload: {
    item: Item
    id?: string
  }
  callback: (succ: boolean, item: Item | null) => void
}

export interface RejectItemAction {
  type: typeof itemsTypes.REJECT_ITEM
  payload: RejectBatchPayload
  callback?: (succ: boolean) => void
}

export interface MoveItemsBatchAction {
  type: typeof itemsTypes.MOVE_ITEMS
  payload: UpdateBatchPayload
  callback?: (succ: boolean) => void
}

export interface UpdateItemTotalsAction {
  type: typeof itemsTypes.UPDATE_ITEM_TOTALS
  payload: any
  callback?: (succ: boolean, item: Item | null) => void
}

export interface UpdateItemTotalsSyncAction {
  type: typeof itemsTypes.UPDATE_ITEM_TOTALS_SYNC
  payload: any
  callback?: (succ: boolean, item: Item | null) => void
}
export interface UpdateItemByPathAction {
  type: typeof itemsTypes.UPDATE_ITEM_BY_PATH
  payload: any
  callback?: (succ: boolean) => void
}

export interface CombineItemsAction {
  type: typeof itemsTypes.COMBINE_ITEMS
  payload: {
    id: string
    request: string[]
    isEstimate?: boolean
  }
  callback?: (succ: boolean) => void
}

export interface DownloadCSVAction {
  type: typeof itemsTypes.DOWNLOAD_ITEMS_CSV
  payload: {
    id: string
    type: 'estimates' | 'jobs',
    orderId?: string
  }
  callback: (succ: boolean, csv: any) => void
}

export interface CloneItemPayload {
  id: string,
}
export interface CloneItemAction {
  type: typeof itemsTypes.CLONE_ITEM
  payload: CloneItemPayload
  callback: (succ: boolean, item?: Item | null) => void
}
export interface EditLaborRateByTerritoryAndCategoryPayload {
  category: string,
  territoryId: string,
  laborRate: number,
}
export interface EditLaborRateByTerritoryAndCategoryResponse {
  itemCount: number,
}
export interface EditLaborRateByTerritoryAndCategoryAction {
  type: typeof itemsTypes.EDIT_LABOR_RATE_BY_TERRITORY_AND_CATEGORY,
  payload: EditLaborRateByTerritoryAndCategoryPayload,
  callback: (succ: boolean, item?: EditLaborRateByTerritoryAndCategoryResponse | null) => void
}

export type ItemsActions =
  | FetchItemsAction
  | FetchInspectionItemsAction
  | SetItemsAction
  | SetItemsByCategoryAction
  | UpdateItemAction
  | DeleteItemAction
  | UpdateBatchAction
  | DeleteBatchAction
  | CreateItemAction
  | RejectItemAction
  | RecallItemsAction
  | MoveItemsBatchAction
  | UpdateItemTotalsAction
  | UpdateItemTotalsSyncAction
  | DeleteEstimateItemsAction
  | UpdateItemByPathAction
  | CombineItemsAction
  | FetchApplianceTypesAction
  | ScanApplianceTagAction
  | ConfirmApplianceTagAction
  | CloneItemAction
  | EditLaborRateByTerritoryAndCategoryAction
/** REDUCER **/
export interface ItemsParams {
  jobId: string
  status: string
  orderId?: string
}

export interface ItemsType {
  items: Item[]
  inspectionItems: Item[]
  itemsByCategory: ItemByCategory[]
  applianceTypes: ApplianceType | null
  applianceTagData: ScanLabel | null
}


export interface ScanLabelImage {
  content: string;
  description: string;
  read_label: boolean;
}
export interface ScanLabel {
  images?: ScanLabelImage[];
  product_type_id: number | string;
  propertyId: string;
  property_uid: string | null;
}


export interface ConfirmAppliance {
  applianceId: string;
  propertyId: string;
  brand_id: number;
  brand_name: string;
  model_number: string;
  productTypeId: number;
  serial_number: string;
  property_uid: string;
  manufacturedYear?: number;
  manufacturedMonth?: number;
  install_date?: string;
  age?: number;
}

export interface Appliance {
  id: string;
  created: string;
  updated: string;
  age: number;
  subscribed: boolean;
  dimensions?: {
    depth_inches: number;
    height_inches: number;
    width_inches: number;
  }
  images: ApplianceImage[];
  errors: any[];
  warnings: any[];
  refreshed: number;
  appliance_uid: string;
  property_uid: string;
  brand_id: number;
  brand_name: string;
  product_type_id: number;
  product_type_name: string;
  sub_product_type_id: number | null;
  sub_product_type_name: string | null;
  manufactured_month: number;
  manufactured_year: number;
  serial_number: string;
  model_number: string;
  recall_number: string | null;
  recall_data: RecallData[];
  expected_life: number;
  identified_manufactured_dates: IdentifiedManufacturedDates;
  product_type_data: any | null;
  remaining_life: number;
  appliance_risk_failure_score: number;
  appliance_risk_failure_score_if_recall_fixed: number | null;
  appliance_data: ApplianceData[];
  install_date?: string;
}

interface ApplianceImage {
  id: string;
  url: string;
  content: string | null;
  description: string;
  created: string;
  source7_id: string | null;
  is_label: boolean;
  vision_data: VisionData;
}

interface VisionData {
  brand_id: number;
  brand_name: string;
  product_type_id: number;
  product_type_name: string;
  model_number: string;
  serial_number: string;
  review_recommended: number | null;
}

interface IdentifiedManufacturedDates {
  id: string;
  month: number;
  years: number[];
  percent_likelihood: PercentLikelihood[];
}

interface PercentLikelihood {
  id: string;
  year: number;
  probability: string;
}

interface ApplianceData {
  id: string;
  field: string;
  value: string;
  s7_appliance_data_id: string | null;
}

export interface PropertyAppliance {
  address: string;
  appliances: Appliance[];
  created: Date;
  errors: string[];
  home_base_property_id: string;
  id: string;
  images: string[];
  pdf_url: string;
  property_uid: string;
  submitter_email: string;
  subscribed: string;
  updated: Date;
  warnings: string[];
  year_built: string;
}

export interface RecallData {
  id: string;
  hazard: string;
  fix: string;
  exact_match: boolean;
  recall_number: string;
  due_to: string;
  recall_url: string;
  date_started_being_sold: string;
  date_stopped_being_sold: string;
  date_recalled: string;
  date_added: string;
};